class ProductCardVariantPrice {
  constructor() {
    this.init();
  }

  init() {
    // Find all product option dropdowns
    const dropdowns = document.querySelectorAll('.product-option-dropdown');
    
    dropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', (e) => {
        this.updatePrice(e.target);
      });
    });
  }

  updatePrice(dropdown) {
    const productCard = dropdown.closest('.card-wrapper');
    if (!productCard) return;

    const selectedOption = dropdown.options[dropdown.selectedIndex];
    const variantPrice = parseFloat(selectedOption.dataset.price);
    const variantComparePrice = parseFloat(selectedOption.dataset.comparePrice || 0);
    const variantTitle = selectedOption.textContent.trim();

    console.log('Variant selected:', {
      title: variantTitle,
      price: variantPrice,
      comparePrice: variantComparePrice
    });

    // Update the price display
    const priceContainer = productCard.querySelector('.price__sale');
    if (priceContainer) {
      const priceElement = priceContainer.querySelector('.price-item--sale');
      if (priceElement) {
        // Format the price with currency
        const formattedPrice = this.formatPrice(variantPrice);
        priceElement.textContent = formattedPrice;
      }

      // Update compare at price if it exists
      const comparePriceElement = priceContainer.querySelector('.price-item--regular');
      if (comparePriceElement && variantComparePrice > variantPrice) {
        const formattedComparePrice = this.formatPrice(variantComparePrice);
        comparePriceElement.textContent = formattedComparePrice;
      }
    }

    // Update the savings calculation
    this.updateSavings(productCard, variantPrice, variantComparePrice);

    // Update the variant ID in the form
    const form = productCard.querySelector('form');
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = selectedOption.value;
      }
    }

    // Update the variant title display if needed
    this.updateVariantTitle(productCard, variantTitle);
  }

  formatPrice(price) {
    // Format price as Indian Rupees
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price / 100); // Shopify prices are in cents
  }

  updateSavings(productCard, price, comparePrice) {
    if (comparePrice <= price) return;

    const savings = comparePrice - price;
    const percentOff = Math.round((savings / comparePrice) * 100);
    
    const savingsElement = productCard.querySelector('.compare-price-info');
    if (savingsElement) {
      const formattedSavings = this.formatPrice(savings);
      savingsElement.textContent = `You Save: ${formattedSavings} (${percentOff}% OFF)`;
    }
  }

  updateVariantTitle(productCard, variantTitle) {
    // Update any elements that show the variant title
    const titleElements = productCard.querySelectorAll('.variant-title');
    titleElements.forEach(element => {
      element.textContent = variantTitle;
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductCardVariantPrice();
});

// Handle Shopify section updates
document.addEventListener('shopify:section:load', () => {
  new ProductCardVariantPrice();
}); 